export default defineNuxtRouteMiddleware(async (to, from) => {
  const facilitySearch = useFacilitySearch();
  const searchStore = useSearchStore();

  if (true) {

    if (to.fullPath.includes('/search') && !from.fullPath.includes('/search')) {
      searchStore.setIsOvernight(to.query.overnight === '1');
    }

    if(to.fullPath.includes('/search')) {
      if (to.query.airport) {
        await useSearch(null, to.query.checkinDate, to.query.checkoutDate || '', true, to.query.airport);
        return;
      }
      if (to.query.collection) {
        await useSearchByCollection(
          to.query.collection,
          to.query.checkinDate,
          to.query.checkoutDate
        );
        return;
      }

      facilitySearch.setParams(to.query);

      await useSearch(
        to.query.facility,
        to.query.checkinDate,
        to.query.checkoutDate || ''
      );
      return;
    }
  }
});
